module.exports = __webpack_public_path__ + "static/media/search1.11915001.svg";